import React from 'react';
import Modalheader from "components/modal/components/header";
import ModalBody from "components/modal/components/body";
import ModalFooter from "components/modal/components/footer";
import Button from "components/button";
import useModal from "components/modal/useModal";

const steps = [
    {
        number: 1,
        title: 'Indiquer votre adresse email',
        description: 'Saisissez l\'adresse email de votre compte Jobbiz',
    },
    {
        number: 2,
        title: 'Saisir le mot de passe reçu par email',
        description: 'Utilisez le mot de passe temporaire que vous avez reçu par email',
    },
    {
        number: 3,
        title: 'Signer tous les documents',
        description: 'Une fois connecté, vous pourrez signer tous vos contrats en une seule fois',
    },
];

const ModalSignatureMultiple = () => {
    const { toggle } = useModal();

    const handleOpenPortal = () => {
        if (process.env.REACT_APP_YOUSIGN_SIGNATURE_PORTAL_URL) {
            window.open(process.env.REACT_APP_YOUSIGN_SIGNATURE_PORTAL_URL, '_blank');
        }
        toggle();
    };

    return (
        <>
            <Modalheader
                hide={toggle}
                hideShow={true}
                description="Pour signer tous vos contrats en une seule fois, suivez ces étapes :"
            >
                Signer tous les contrats
            </Modalheader>
            <ModalBody>
                <div className="flex flex-col gap-6">
                    <div className="flex flex-col gap-4">
                        {steps.map((step) => (
                            <div key={step.number} className="flex items-start gap-4 p-4 bg-gray-50 rounded-lg">
                                <div className="flex-shrink-0 w-8 h-8 flex items-center justify-center bg-yellow-500 text-white rounded-full font-bold text-sm">
                                    {step.number}
                                </div>
                                <div className="flex flex-col gap-1">
                                    <span className="font-semibold text-gray-800">{step.title}</span>
                                    <span className="text-sm text-gray-500">{step.description}</span>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </ModalBody>
            <ModalFooter>
                <Button size="LG" color="SECONDARY" onClick={toggle}>
                    Annuler
                </Button>
                <Button size="LG" color="PRIMARY" onClick={handleOpenPortal}>
                    Ouvrir le portail de signature
                </Button>
            </ModalFooter>
        </>
    );
};

export default ModalSignatureMultiple;
